export default __webpack_public_path__ + "static/media/readmore-dots.b9a075e6.svg";